import { Component, Input, ViewChild } from '@angular/core'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'

@Component({
  selector: 'app-default-paginator',
  standalone: true,
  imports: [MatPaginatorModule],
  template: `
    <mat-paginator
      #paginatorRef
      [length]="length"
      [pageSize]="internalPageSize"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>
  `
})
export class DefaultPaginatorComponent {
  @Input() length = 0
  @Input() set pageSize(value: number) {
    this.internalPageSize = value
    if (this.matPaginator) this.matPaginator.pageSize = value
  }
  get pageSize(): number { return this.matPaginator?.pageSize ?? this.internalPageSize }
  @Input() pageSizeOptions = [10, 20, 50, 100]
  @ViewChild('paginatorRef', { static: true }) matPaginator!: MatPaginator

  internalPageSize = 10

  get pageIndex(): number { return this.matPaginator.pageIndex }
  set pageIndex(value: number) { this.matPaginator.pageIndex = value }
  get page() { return this.matPaginator.page }
  get initialized() { return this.matPaginator.initialized }
  firstPage() { this.matPaginator.firstPage() }
  lastPage() { this.matPaginator.lastPage() }
  _changePageSize(size: number) { this.matPaginator._changePageSize(size) }
}
